import React, { useEffect, useRef } from "react";
import "../styles/cursor.css";
import gsap from "gsap";

const Cursor = () => {
  const cursorRef = useRef(null);
  const cursorDotRef = useRef(null);

  useEffect(() => {
    const updateCursor = (e) => {
      gsap.to(cursorRef.current, {
        duration: 0.6,
        x: e.pageX - 15,
        y: e.pageY - 15,
        ease: "power3.out",
      });
      cursorDotRef.current.style.top = e.pageY + "px";
      cursorDotRef.current.style.left = e.pageX + "px";
    };

    const handleMouseLeave = () => {
      cursorRef.current.classList.remove("cursorBlock");
      cursorRef.current.classList.add("cursorNone");
      cursorDotRef.current.classList.remove("cursorBlock");
      cursorDotRef.current.classList.add("cursorNone");
    };

    const handleMouseOver = () => {
      cursorRef.current.classList.remove("cursorNone");
      cursorRef.current.classList.add("cursorBlock");
      cursorDotRef.current.classList.remove("cursorNone");
      cursorDotRef.current.classList.add("cursorBlock");
    };

    const handleButtonHover = () => {
      cursorRef.current.style.opacity = 0;
      cursorDotRef.current.style.opacity = 0;
    };

    const handleButtonLeave = () => {
      cursorRef.current.style.opacity = 1;
      cursorDotRef.current.style.opacity = 1;
    };

    document.addEventListener("mouseleave", handleMouseLeave);
    document.addEventListener("mouseover", handleMouseOver);
    window.addEventListener("mousemove", updateCursor);

    const attachButtonListeners = () => {
      const buttons = document.querySelectorAll("[data-cursor=true]");
      buttons.forEach((button) => {
        button.addEventListener("mouseenter", handleButtonHover);
        button.addEventListener("mouseleave", handleButtonLeave);
      });
    };

    // Initial attachment of button listeners
    attachButtonListeners();

    // Use a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === "childList" || mutation.type === "attributes") {
          attachButtonListeners();
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    return () => {
      document.removeEventListener("mouseleave", handleMouseLeave);
      document.removeEventListener("mouseover", handleMouseOver);
      window.removeEventListener("mousemove", updateCursor);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <div className="cursor" ref={cursorRef}></div>
      <div className="cursor_dot" ref={cursorDotRef}></div>
    </>
  );
};

export default Cursor;
